import { FC, useCallback, useEffect } from 'react';

import { AuthModal } from 'interfaces/auth';
import { IModalProps as IProps } from 'interfaces/auth';

import { Stepper } from 'components/_basic/Stepper/Stepper';
import { AuthModalView } from 'components/AuthModals';

import { useAuthModalsContext } from '../AuthModals';
import {
  ResetPasswordContextProvider,
  useResetPasswordContext,
} from './ResetPasswordContextProvider/ResetPasswordContextProvider';
import { EnterCodeStep } from './ResetPasswordForms/EnterCodeStep/EnterCodeStep';
import { EnterEmailStep } from './ResetPasswordForms/EnterEmailStep/EnterEmailStep';
import { EnterPasswordStep } from './ResetPasswordForms/EnterPasswordStep/EnterPasswordStep';

export const ResetPassword: FC<IProps> = ({ isModalOpened, onModalClose }) => {
  const stepArray = [EnterEmailStep, EnterCodeStep, EnterPasswordStep];
  const { setResetFormData, setAuthModal } = useAuthModalsContext();

  const resetFormData = useCallback(() => {
    setResetFormData({ email: '', code: '', password: '', confirmPassword: '' });
  }, [setResetFormData]);

  const closeButtonClickHandler = (): void => {
    resetFormData();
    setAuthModal(AuthModal.LOGIN);
  };

  useEffect(() => {
    if (!isModalOpened) {
      resetFormData();
    }
  }, [isModalOpened, resetFormData]);

  return (
    <ResetPasswordContextProvider>
      <AuthModalView isModalOpened={isModalOpened} onModalClose={onModalClose}>
        <Stepper useModalContext={useResetPasswordContext} stepForms={stepArray} onClose={closeButtonClickHandler} />
      </AuthModalView>
    </ResetPasswordContextProvider>
  );
};
